import "./mezcal-product-view.css";
import blueCheck from "../../images/mezcales/blue-check.svg";
import truck from "../../images/mezcales/truck-vector.svg";
import addButton from "../../images/compra/add-item.svg";
import minusButton from "../../images/compra/minus-item.svg";
import amazon from "../../images/purchase-info/amazon.svg";
import americanExpress from "../../images/purchase-info/american-express.svg";
import laEuropea from "../../images/purchase-info/la_europea.svg";
import mastercard from "../../images/purchase-info/mastercard.svg";
import openpay from "../../images/purchase-info/openpay.svg";
import visa from "../../images/purchase-info/visa.svg";

import { useEffect, useState } from "react";

function PurchaseInfo(props) {
  const [items, setItems] = useState(0);

  const addItem = () => {
    setItems(items + 1);
  };

  const substractItem = () => {
    if (items === 0) {
      setItems(0);
    } else {
      setItems(items - 1);
    }
  };

  return (
    <>
      <div className="purchase-info-main-container">
        <div className="purchase-mezcal-container">
          <div className="purchase-info">
            <h5>{props.mezcal}</h5>
            <h3>${props.precio}</h3>
            <p>O hasta con {props.costoPuntos} puntos</p>
            <p>
              <img src={blueCheck} style={{ marginRight: "0.5rem" }} />
              Te da {props.puntosObtener} puntos por botella
            </p>
            <p>
              <img src={truck} style={{ marginRight: "0.5rem" }} />
              Entrega gratis en Ciudad de M&eacute;xico
            </p>
            <p>Stock disponible</p>
            <div className="add-items-container">
              <div className="minus-item" onClick={substractItem}>
                <img src={minusButton} />
              </div>
              <div className="items-number">{items}</div>
              <div className="add-item" onClick={addItem}>
                <img src={addButton} />
              </div>
            </div>
          </div>
          <div className="button-container">
            <button className="button-carrito">Agregar al carrito</button>
            <button className="button-comprar">Comprar ahora</button>
          </div>
          <div className="openpay-info-container">
            <div className="openpay-first-row">
              <img
                src={openpay}
                width="120px"
                style={{ marginRight: "20px" }}
              />
              <p>Compra procesada a trav&eacute;s de Openpay</p>
            </div>
            <div className="openpay-second-row">
              <img src={mastercard} />
              <img src={visa} />
              <img src={americanExpress} />
            </div>
          </div>
        </div>
        <div className="purchase-affiliates-container">
          <p>Disponible tambi&eacute;n en:</p>
          <div className="affiliates-img-container">
            <div className="amazon-img-container">
              <img src={amazon} width="120px" />
            </div>
          </div>
          <p>y tiendas:</p>
          <div className="affiliates-img-container">
            <div className="la-europea-img-container">
              <img src={laEuropea} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PurchaseInfo;
